export default "__VITE_ASSET__81046b4a__"